import styled from "@emotion/styled";
import { Button, EditModal, ViewMoreTable } from "@src/components";
import { useGetConnectionList, useGetSusList } from "@src/hooks/queries/usePartner";
import { ConvertPrice } from "@src/utils/units";
import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getPayBackSubsListColumns } from "./PayBackSubsListColumns";
import { getPayBackUserListColumns } from "./PayBackUserListColumns";

interface PayBackInfoBoxProps {
    detailData: any;
}

const PayBackInfoBox = ({ detailData }: PayBackInfoBoxProps) => {
    const { no } = useParams();
    const navigate = useNavigate();
    const [modalState, setModalState] = useState<{
        isShow: boolean;
        type: string;
    }>({
        isShow: false,
        type: "userList",
    });

    const connectionColumns = getPayBackUserListColumns(navigate);
    const subsColumns = getPayBackSubsListColumns(navigate);

    const { data: connectionData, refetch: refetchConnection } = useGetConnectionList(Number(no));

    const { data, refetch } = useGetSusList(Number(no));

    useEffect(() => {
        no && refetchConnection();
    }, [no]);

    useEffect(() => {
        no && refetch();
    }, [no]);

    return (
        <>
            <StyledContentsBox>
                <div className="titleDiv">
                    <span>페이백 정보</span>
                    <div style={{ display: "flex", gap: "13px" }}>
                        <Button
                            label="회원 리스트"
                            color="whiteOp"
                            size="small"
                            handleClick={(e) => {
                                setModalState({
                                    isShow: true,
                                    type: "userList",
                                });
                            }}
                            styles={{
                                boxSizing: "border-box",
                                fontSize: "12px",
                                fontWeight: 400,
                                lineHeight: "21px",
                                width: "86px",
                                height: "24px",
                            }}
                        />
                        <Button
                            label="회원 현황"
                            color="whiteOp"
                            size="small"
                            handleClick={(e) => {
                                setModalState({
                                    isShow: true,
                                    type: "subsList",
                                });
                            }}
                            styles={{
                                boxSizing: "border-box",
                                fontSize: "12px",
                                fontWeight: 400,
                                lineHeight: "21px",
                                width: "86px",
                                height: "24px",
                            }}
                        />
                        {/* <Button
                            label="비율 수정"
                            color="whiteOp"
                            size="small"
                            handleClick={(e) => {
                                const { userNo } = location.state as any;
                                // navigate(`/partner/update/${userNo}`, {
                                //     state: { userNo: userNo, type: "update" },
                                // });
                            }}
                            styles={{
                                boxSizing: "border-box",
                                fontSize: "12px",
                                fontWeight: 400,
                                lineHeight: "21px",
                                width: "86px",
                                height: "24px",
                            }}
                        /> */}
                    </div>
                </div>
                <div className="contents">
                    <div className="titleContents">
                        <div className="nickname">{detailData.code}</div>
                        <div className="profileMetrics">
                            <div className="metric metricPrimary">
                                <span className="metricLabel">코드를 입력한 회원</span>
                                <span className="metricValue">{detailData.connectionCount}명</span>
                            </div>
                            <div className="metric metricPrimary">
                                <span className="metricLabel">구독 결제완료(페이백 대상)</span>
                                <span className="metricValue">{detailData.paybackCount}명</span>
                            </div>
                            <div className="metric metricPrimary">
                                <span className="metricLabel">적용 페이백 비율</span>
                                <span className="metricValue">{detailData.paybackRate}%</span>
                            </div>
                        </div>
                    </div>
                    <div className="salesDiv">
                        <div className="salesTitle">
                            <div className="title">{detailData.calc.month} 정산</div>
                            <div className="salesMeta">
                                <span>
                                    정산기간 : {detailData.calc.startDate} ~ {detailData.calc.endDate}
                                </span>
                                <span className="salesMetaDivider" aria-hidden />
                                <span>정산예정일 : {detailData.calc.expectedDate}</span>
                            </div>
                        </div>
                        <div className="boxWrap">
                            <div className="paymentAmount box">
                                <div className="title">결제액</div>
                                <div className="money">{ConvertPrice(detailData.calc.totalAmount)}</div>
                            </div>
                            <div className="cancel box">
                                <div className="title">결제취소액</div>
                                <div className="money">{ConvertPrice(detailData.calc.canceledAmount)}</div>
                            </div>
                            <div className="netPayment box">
                                <div className="title">순결제액</div>
                                <div className="money">{ConvertPrice(detailData.calc.amount)}</div>
                            </div>
                            <div className="descText">※ 현재 시점까지 집계된 금액이 노출됩니다</div>
                        </div>
                    </div>
                </div>
            </StyledContentsBox>
            <EditModal
                buttonText=""
                handleBtnClick={() => {}}
                handleOpenModal={() => {
                    setModalState({
                        ...modalState,
                        isShow: false,
                    });
                }}
                size="big"
                title={modalState.type === "userList" ? "회원 리스트" : "구독 결제완료(페이백 대상) 현황"}
                isModalShow={modalState.isShow}
                dimClose={true}
                checkCloseModal={true}
                deleteButton={true}
            >
                <StyledUserListModal>
                    {modalState.type === "userList" && (
                        <>
                            <div className="countList">
                                <div className="countItem">
                                    누적: <span>{ConvertPrice(connectionData?.result.total ?? 0)}</span>명
                                </div>
                                <div className="countItem">
                                    페이백 대상: <span>{ConvertPrice(connectionData?.result.paybackCount ?? 0)}</span>명
                                </div>
                                <div className="countItem">
                                    파트너 종료:{" "}
                                    <span>{ConvertPrice(connectionData?.result.expiredPartnerCount ?? 0)}</span>명
                                </div>
                                <div className="countItem">
                                    파트너 해지:{" "}
                                    <span>{ConvertPrice(connectionData?.result.canceledPartnerCount ?? 0)}</span>명
                                </div>
                            </div>

                            <ViewMoreTable
                                FixedHeight={300}
                                columns={connectionColumns}
                                data={connectionData?.result.list ?? []}
                                handleViewMore={function noRefCheck() {}}
                                isRefetching={true}
                            />
                        </>
                    )}
                    {modalState.type === "subsList" && (
                        <ViewMoreTable
                            FixedHeight={300}
                            columns={subsColumns}
                            data={data?.result ?? []}
                            handleViewMore={function noRefCheck() {}}
                            isRefetching={true}
                        />
                    )}
                </StyledUserListModal>
            </EditModal>
        </>
    );
};

export default PayBackInfoBox;

const StyledContentsBox = styled.div`
    width: 1000px;
    height: fit-content;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
    .titleDiv {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0px 13px;
        height: 43px;
        width: 100%;
        background-color: #fbf4fe;
        border: 1px solid #d8d8d8;
        & > span {
            font-weight: 700;
            font-size: 20px;
            line-height: 24px;
        }
    }
    .contents {
        display: flex;
        flex-direction: column;
        height: fit-content;
        border-top: none;
        border: 1px solid #d8d8d8;
        padding: 24px;
        gap: 41px;

        .titleContents {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            gap: 32px;
            .nickname {
                font-size: 36px;
                font-weight: 700;
                line-height: 48px;
                flex-shrink: 0;
                max-width: 42%;
            }
            .profileMetrics {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                justify-content: flex-end;
                gap: 80px;
                flex: 1;
                min-width: 0;
            }
            .metric {
                display: flex;
                flex-direction: column;
                text-align: center;
                gap: 6px;
                min-width: 0;
            }
            .metricLabel {
                font-size: 16px;
                font-weight: 500;
                color: #000;
                line-height: 1.35;
                max-width: 200px;
            }
            .metricValue {
                font-size: 24px;
                font-weight: 700;
                line-height: 1.2;
            }
            .metricPrimary .metricValue {
                color: #111111;
            }
        }
        .salesDiv {
            display: flex;
            flex-direction: column;
            gap: 16px;
            margin: 0;
            width: 100%;
            .salesTitle {
                display: flex;
                flex-direction: column;
                gap: 10px;
                .title {
                    font-size: 24px;
                    font-weight: 700;
                    line-height: 1.3;
                }
                .salesMeta {
                    display: flex;
                    flex-direction: row;
                    flex-wrap: wrap;
                    align-items: center;
                    gap: 12px;
                    font-size: 13px;
                    font-weight: 400;
                    color: #888888;
                }
                .salesMetaDivider {
                    display: inline-block;
                    width: 1px;
                    height: 14px;
                    background-color: #d0d0d0;
                    flex-shrink: 0;
                }
            }
            .boxWrap {
                display: flex;
                flex-direction: row;
                flex-wrap: nowrap;
                gap: 20px;
                position: relative;
                padding-bottom: 28px;
                width: 100%;
                .box {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    flex: 1 1 0;
                    min-width: 0;
                    max-width: 280px;
                    height: 96px;
                    padding: 12px 8px;
                    border-radius: 12px;
                    box-sizing: border-box;
                    gap: 14px;
                }
                .box .title {
                    font-size: 15px;
                    font-weight: 700;
                }
                .box .money {
                    font-size: 22px;
                    font-weight: 700;
                }
                .paymentAmount {
                    background-color: #f1f3ff;
                    .title,
                    .money {
                        color: #2f3f8f;
                    }
                }
                .cancel {
                    background-color: #fff1f1;
                    .title,
                    .money {
                        color: #9b2c2c;
                    }
                }
                .netPayment {
                    background-color: #f1fff3;
                    .title,
                    .money {
                        color: #1d6f42;
                    }
                }
                .descText {
                    position: absolute;
                    bottom: 8px;
                    right: 0;
                    font-size: 14px;
                    color: #999999;
                }
            }
        }
    }
`;

const StyledUserListModal = styled.div`
    display: flex;
    flex-direction: column;
    gap: 8px;
    .countList {
        display: flex;
        gap: 15px;
        align-items: center;
        .countItem {
            & > span {
                font-weight: 700;
            }
        }
    }
    & > div {
        & > .viewMoreButton {
            display: none;
        }
    }
`;
